import { render, staticRenderFns } from "./TheNotifications.vue?vue&type=template&id=0170bd7f&scoped=true&"
import script from "./TheNotifications.vue?vue&type=script&scoped=true&lang=js&"
export * from "./TheNotifications.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./TheNotifications.vue?vue&type=style&index=0&id=0170bd7f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0170bd7f",
  null
  
)

export default component.exports